<template>
  <div v-if="messages.length > 0" class="error">
    <ul>
      <validation-message v-for="message in messages" :key="message.code" :message="message"/>
    </ul>
  </div>
</template>
<script>
import ValidationMessage from './ValidationMessage'

export default {
  name: 'ValidationMessageList',
  components: {
    ValidationMessage
  },
  props: {
    translationNameSpace: {
      type: String,
      required: true
    },
    propertyPath: {
      type: String,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },
  computed: {
    messages () {
      const messages = []
      Object.keys(this.$v).map(key => {
        if (this.$v.$error && key.charAt(0) !== '$' && !this.$v[key]) {
          messages.push({
            translationNameSpace: this.translationNameSpace,
            propertyPath: this.propertyPath,
            code: key
          })
        }
      })
      return messages
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ValidationMessageList.vue